import React from "react";
import { Link, useLocation } from "react-router-dom";
import Scrollbars from "react-custom-scrollbars-2";
import logo from "../../assets/images/logo.png";
import "./sidebar.css";
import { useState } from "react";
import { useAuthContext } from "../../ContextAPI/AuthContextAPI";
import { ReactComponent as Elliment } from "../../assets/images/element.svg";
import { ReactComponent as Category } from "../../assets/images/category.svg";
import { ReactComponent as Setting } from "../../assets/images/setting.svg";
import { ReactComponent as Book } from "../../assets/images/book.svg";
import { ReactComponent as ProfileUser } from "../../assets/images/profile-user.svg";
import { ReactComponent as Role } from "../../assets/images/users-round.svg";
import { ReactComponent as Card } from "../../assets/images/cards.svg";
import { ReactComponent as People } from "../../assets/images/people.svg";
import { ReactComponent as Ticket } from "../../assets/images/messages.svg";
import { ReactComponent as Blog } from "../../assets/images/blog.svg";
import NewsLetter from "../../pages/NewsLetter/NewsLetter";
// import home from "../../../assets/images/home.svg";

const SideBar = () => {
  const [isSideMenu, setSideMenu] = useState("");
  const location = useLocation();
  const { currentSidebar, setCurrentSidebar } = useAuthContext();
  const pathName = "";
  // console.log(location, "loca");

  const toggleSidebar = (value) => {
    console.log(value, "value");
    if (isSideMenu == value) {
      setSideMenu(null);
    } else {
      setSideMenu(value);
    }
  };

  const menus = [
    {
      id: 0,
      path: "/dashboard",
      role: "",
      name: "Dashboard",
      subRouting: false,
      icon: <Elliment />,
    },
    {
      id: 1,
      path: "/role",
      role: "",
      name: "Role",
      subRouting: false,
      icon: <Setting />,
    },
    {
      id: 2,
      path: "/category",
      role: "",
      name: "Category",
      subRouting: false,
      icon: <Category />,
    },

    {
      id: 3,
      path: "/employee-management",
      role: "",
      name: "Employee",
      subRouting: false,
      icon: <People />,
    },
    {
      id: 4,
      path: "#",
      role: "",
      name: "Course Management",
      subRouting: true,
      icon: <Book />,
      subMenu: [
        {
          path: "/add-course",
          role: "",
          name: "Add Course",
        },
        {
          path: "/course",
          role: "",
          name: "Course List",
        },
        // {
        //   path: "/popular",
        //   role: "",
        //   name: "Popular",
        // },
        // {
        //   path: "/most-purchased",
        //   role: "",
        //   name: "Most Purchased",
        // },
      ],
    },
    {
      id: 5,
      path: "#",
      role: "",
      name: "User Management",
      subRouting: true,
      icon: <ProfileUser />,
      subMenu: [
        {
          path: "/students",
          role: "",
          name: "Normal User",
        },
        {
          path: "/premium-student",
          role: "",
          name: "Premium User",
        },
      ],
    },
    // {
    //   id: 3,
    //   path: "/schedule",
    //   role: "",
    //   name: "Schedule",
    //   subRouting: false,
    //   icon: <Calendar />,
    // },
    {
      id: 6,
      path: "/transactions",
      role: "",
      name: "Transactions",
      subRouting: false,
      icon: <Card />,
    },
    // {
    //   id: 5,
    //   path: "/group",
    //   role: "",
    //   name: "Group",
    //   subRouting: false,
    //   icon: <People />,
    // },
    // {
    //   id: 6,
    //   path: "/live-class",
    //   role: "private",
    //   name: "Live Class",
    //   subRouting: false,
    //   icon: <Message />,
    // },
    // {
    //   id: 7,
    //   path: "/message",
    //   role: "",
    //   name: "Message",
    //   subRouting: false,
    //   icon: <Sms />,
    // },
    {
      id: 7,
      path: "/blog",
      role: "",
      name: "Blog",
      subRouting: false,
      icon: <Book />,
    },
    {
      id: 7,
      path: "/tickets",
      role: "",
      name: "Ticket",
      subRouting: false,
      icon: <Ticket />,
    },
    {
      id: 7,
      path: "/newsletter",
      role: "",
      name: "NewsLetter",
      subRouting: false,
      icon: <Ticket />,
    },

    // {
    //   id: 1,
    //   path: "#",
    //   role: "",
    //   name: "Users",
    //   subRouting: true,
    //   subMenu: [
    //     {
    //       path: "/ownerUsers",
    //       role: "",
    //       name: "Owners",
    //     },
    //   ],
    //   icon: <i class="fas fa-user"></i>,
    // },

    // {
    //   id: 2,
    //   path: "#",
    //   role: "",
    //   name: "Pet Details",
    //   subRouting: true,
    //   subMenu: [
    //     {
    //       path: "/petType",
    //       role: "",
    //       name: "Type",
    //     },
    //     {
    //       path: "/petColour",
    //       role: "",
    //       name: "Colour",
    //     },
    //   ],
    //   icon: <i class="fas fa-paw"></i>,
    // },

    // {
    //   id: 8,
    //   path: "#",
    //   role: "",
    //   name: "Support",
    //   subRouting: true,
    //   subMenu: [
    //     {
    //       path: "/ownerTickets",
    //       role: "",
    //       name: "Owner Tickets",
    //     },
    //     {
    //       path: "/grommerTickets",
    //       role: "",
    //       name: "Grommer Tickets",
    //     },
    //     {
    //       path: "/vetTickets",
    //       role: "",
    //       name: "Vet Tickets",
    //     },
    //   ],
    //   icon: <i class="fas fa-headset"></i>,
    // },
  ];

  return (
    <div className="sidebar" id="sidebar">
      {/* <div className="dashboard_logo">
        <img src={logo} alt="" />
      </div> */}
      <div className="dashboard_logo">
        <img src={logo} alt="" />
      </div>
      <Scrollbars
        autoHide
        autoHideTimeout={1000}
        autoHideDuration={200}
        autoHeight
        autoHeightMin={0}
        autoHeightMax="95vh"
        thumbMinSize={30}
        universal={false}
        hideTracksWhenNotNeeded={true}
      >
        <div className="sidebar-inner slimscroll">
          <div id="sidebar-menu" className="sidebar-menu">
            {/* Main Menu */}

            <ul>
              {menus.map((menu, index) => {
                return (
                  <>
                    {menu ? (
                      <li
                        className={`${
                          menu.path === location.pathname
                            ? "active submenu"
                            : "submenu"
                        }`}
                        key={index}
                      >
                        <Link
                          to={menu.path}
                          className={isSideMenu == index ? "subdrop" : ""}
                          onClick={() => toggleSidebar(menu.id)}
                        >
                          {menu?.icon}
                          <span className="menu-name">{menu.name}</span>
                          {menu.subRouting ? (
                            <span className="menu-arrow"></span>
                          ) : (
                            ""
                          )}
                        </Link>

                        {isSideMenu == index ? (
                          <ul
                            style={{
                              display: isSideMenu == index ? "block" : "none",
                            }}
                          >
                            {menu.subRouting &&
                              menu?.subMenu?.map((sub, index) => {
                                return (
                                  <>
                                    <li key={index}>
                                      <Link
                                        to={sub.path}
                                        className={`${
                                          sub.path === location.pathname
                                            ? "sub_menu active"
                                            : "sub_menu"
                                        }`}
                                      >
                                        <span
                                          className={
                                            sub.path === location.pathname
                                              ? "custom_icon active"
                                              : "custom_icon"
                                          }
                                        ></span>

                                        <span className="menu-name">
                                          {sub.name}
                                        </span>
                                      </Link>
                                    </li>
                                  </>
                                );
                              })}
                          </ul>
                        ) : (
                          ""
                        )}
                      </li>
                    ) : (
                      ""
                    )}
                  </>
                );
              })}
            </ul>

            {/* /Main Menu*/}
          </div>
        </div>
      </Scrollbars>
    </div>
  );
};

export default SideBar;
